export const HIGHER_EDU_OPTIONS = [
  "1th",
  "2th",
  "3th",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
  "12th Arts",
  "12th Science",
  "12th Commerce",
  "B. COM",
  "M. COM",
  "BCA",
  "MCA",
  "ITI",
  "B.ed",
  "B. sc",
  "M. sc",
  "BA",
  "MA",
  "B.pharm",
  "M.pharm",
  "LLB",
  "MBBS",
  "BAMS",
  "BE CIVIL",
  "BE MECHANICAL",
  "BE ELECTRICAL",
  "BE AUTO",
  "BE COMPUTER",
  "BE IT",
  "DIPLOMA CIVIL",
  "DIPLOMA MECHANICAL",
  "DIPLOMA COMPUTER",
  "DIPLOMA IT",
  "ME CIVIL",
  "ME MECHANICAL",
  "ME COMPUTER",
  "ME IT",
];

export const DEPARTMENT_OPTIONS = [
  "સમાજ સમાચાર",
  "ACCOUNT",
  "SPORTS",
  " સામાજિક કાર્યક્રમ",
  "EMERGENCY",
  "EDUCATION",
  "MEDICAL",
  "STORAGE",
];

export const SUB_CASTE_OPTIONS = [
  "આડીસરા",
  "મીઠાવીયા",
  "વાઘાણી",
  "હમીપરા",
  "દાત્રણીયા",
  "ગાંગાણી",
  "વારૈયા",
  "નાયકીયા",
  "મેમદાવાદી",
  "એવારીયા",
  "ચંદુરા",
  "ગોત્રકિયા",
  "રાપુસા",
  "સુંવર",
  "નાથાણી",
  "પાણવીયા",
  "પુરાણીયા",
  "જેકડીયા",
  "ચોનાણી",
  "કોરડીયા",
];

export const OTHER_ACTIVITY_OPTIONS = [
  "અભ્યાસ ચાલુ છે",
  "પ્રાઇવેટ જોબ",
  "ગવર્મેન્ટ જોબ",
  "કડિયાકામ",
  "પોતાનો બિઝનેસ",
  "Foreign",
];

export const HOBBY_OPTIONS = [
  "Painting or Drawing",
  "Photography",
  "Playing a Musical Instrument",
  "Writing or Journalism",
  "Reading Books",
  "Gardening or Plant Care",
  "Cooking or Baking",
  "DIY Crafts",
  "Hiking or Nature Walking",
  "Yoga or Meditation",
  "Playing Sports",
  "Dancing",
  "Knitting or Crocheting",
  "Playing Video Games",
  "Woodworking",
  "Collecting",
  "Learning a New Language",
  "Volunteering",
  "Fishing or Angling",
  "Traveling and Exploring New Places",
];

export const CITY = [
  "કલોલ",
  "આણંદ",
  "ડીસા",
  "વાવ",
  "બેલા",
  "હિંમતનગર",
  "ખંભાત",
  "માંડવી",
  "દેશલપર",
  "ચિત્રોડ",
  "તાપી",
  "બારડોલી",
  "પુના",
  "ભીમાસર",
  "ગાંધીનગર",
  "અંજાર ",
  "વલસાડ",
  "ગાંધીધામ",
  "સેવાલિયા",
  "ગાગોદર",
  "બાજીપુરા",
  "કીમ",
  "વડોદરા",
  "ભંગેરા",
  "ભુજ",
  "ચલથાણ",
  "નાદેલાવાંઢ",
  "ધમડકા",
  "મોરબી",
  "ઘરાણા",
  "સાંતલપુર",
  "અમદાવાદ",
  "અધોઈ",
  "નવાગામ-રાપર",
  "પાલનપુર",
  "અમરાપર",
  "આદિપૂર",
  "વિસનગર",
  "સુરત",
  "પલાંસવા",
  "ભાભર",
  "સામખીયારી",
  "ભરુચ",
  "પેટલાદ",
  "મહેસાણા",
  "લલીયાણા",
  "નાની હમીપર",
  "મુંબઈ",
  "મુંદ્રા",
  "ખાંડેક",
  "ભચાઉ",
  "જાટાવાડા",
  "ફતેહગઢ",
  "રાધનપુર",
  "મોમાઈ મોરા",
];

export const BLOOD_GROUP = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];

export const PASSWORD_HELP_GUJARATI =
  "આપનો પાસવર્ડ બનાવવા માટે, આપે આપના મોબાઈલ નંબરના છેલ્લા 4 અંકો અને જન્મ વર્ષનો ઉપયોગ કરવો હશે. ઉદાહરણ તરીકે, જો આપનો મોબાઈલ નંબર 123456789 છે અને જન્મ વર્ષ 2004 છે, તો આપનો પાસવર્ડ 67892004 હશે.";
export const PASSWORD_HELP_ENGLISH =
  "To create your password, you will use the last 4 digits of your mobile number and your birth year. For example, if your mobile number is 123456789 and your birth year is 2004, your password will be 67892004.";
